<template>
  <div>
    <Idle
      @idle="logout"
      @remind="remind"
      :reminders="[10, 20, 30]"
      :events="triggerEvents"
      :duration="duration"
    ></Idle>
    <v-dialog
      transition="scroll-y-transition"
      width="450"
      v-model="dialog"
      persistent
    >
      <v-card rounded="lg" class="pa-1">
        <v-card-title class="font-weight-bold">Inactivity</v-card-title>
        <v-card-text>
          You have been inactive for a while. You will be logged out in
          {{ time }} seconds.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            class="text-none font-weight-regular"
            min-height="40"
            @click="dialog = false"
            >Stay logged in</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { IDLE_TIMER } from '@/lib/constants/env';
import { mapState } from 'vuex';
import Idle from '@/modules/shared/components/Idle.vue';
export default {
  components: { Idle },
  data() {
    return {
      triggerEvents: [
        'mousemove',
        'mousedown',
        'resize',
        'keydown',
        'touchstart',
        'wheel',
        'click'
      ],
      time: null,
      dialog: false,
      duration: IDLE_TIMER || 3600 // update to 20 mins in production
    };
  },
  computed: {
    ...mapState('authModule', ['user'])
  },
  methods: {
    async logout() {
      this.dialog = false;
      //For production purposes
      await this.$store.dispatch('authModule/signOut', this.user.id);
      // For testing purposes
      this.$store.commit('authModule/CLEAR_TOKENS');
      this.$store.commit('authModule/CLEAR_USER');
      this.$router.replace('/auth/login');
    },
    remind(time) {
      this.time = time;
      this.dialog = true;
    }
  }
};
</script>
